import React, { useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Container, Row, Col, Button, Popover, OverlayTrigger } from 'react-bootstrap';
import Call_php_iniziale from './components/load_call_php_start';
import Dropdown_materie from './components/bootstrap_drop_materia';
import Dropdown_jump from './components/bootstrap_drop_jump';
import Scegli_materie from './components/bootstrap_lista_materie';
import Accordion_risposta from './components/bootstrap_accordion_risposta';
import Risposta_visualizza from './components/risposta_visualizza';

import Accordion_domanda from './components/bootstrap_accordion_domanda';

import Salvataggio from './components/save_call_php_file';
import Play_in_automatico from './components/bootstrap_togglebutton';
import Editor_prova from './components/editor_slate';
import Nuova_domanda from './components/nuova_domanda';
import File_mp3_load from './components/load_file_mp3';
import Gestione_file_mp3 from './components/gestione_file_mp3';

import Editor_risposte from './components/editor_perfetto';


const App = () => {

  const [aggiorna_lista, SET_aggiorna_lista] = useState(0);

  const [aggiorna_lista_file_stornati, SET_aggiorna_lista_file_stornati] = useState(false);
  const [indice, set_funzione_indice] = useState(5);
  const [index, setindex] = useState(0);
  const [fName, setfName] = useState('');
  const [valore_minimo_sottrazione, SET_valore_minimo_sottrazione] = useState(0);

  const [lista_file_mp3, SET_lista_file_mp3] = useState([]);
  const [lista_materie, SET_lista_materie] = useState([{ materia: 'inglese', attivo: true }, { materia: 'reactjs', attivo: true }, { materia: 'javascript', attivo: true },]);
  const [play_lista, SET_funzione_play_lista] = useState([]);
  const [dati_utente, funzione_set_dati_utente] = useState({ nome: 'renato', nome: 'zero', file: [] });
  const [salva_dati, SET_salva_dati] = useState(false);
  const [play_spunta_ripetuto, funzione_play_spunta_ripetuto] = useState(false);
  const [play_ripetuto, funzione_play_ripetuto] = useState(true);

  const [play_indice, funzione_play_indice] = useState(0);

  useEffect(() => {
    console.log('USEEFFECT +++++ App.js ' + aggiorna_lista)
    if (aggiorna_lista > 1) {
      SET_salva_dati(true)
    }
    if (aggiorna_lista > 0) {
      console.log('USEEFFECT App.js')
      SET_aggiorna_lista_file_stornati(true)
      SET_aggiorna_lista(0)
    }

  }, [aggiorna_lista]);


  //  return () => clearTimeout(timer);



  const cambiaindice = (e) => {
    e.preventDefault();
    set_funzione_indice(e.target.value)
  }






  const trova_mp3_per_play = () => {
    // aumenta l'indice aux fino a quando una domanda non arriva al momento di essere mandata in play 
    var lista_file = lista_file_mp3
    var continua = true
    while (continua) {

      var roots = lista_file.map(function (item, index) {
        lista_file[index].indice_aux++
        if (lista_file[index].indice_end - lista_file[index].indice_aux < 1) {
          continua = false
        }
        //        console.log('swap' + index + ' - ' + lista_file.length)
      });
    }
    SET_lista_file_mp3(lista_file)
    SET_aggiorna_lista(2)
    //    funzione_set_aggiornamento(true)
  }


  function colorazione(index2) {

    var colore = 'black'
    var colore_bordo = 'solid red'
    if (lista_file_mp3[index2].colore_bordo != undefined) {
      colore_bordo = '3px solid ' + lista_file_mp3[index2].colore_bordo
    }
    var hStyle = { backgroundColor: 'lightgray', color: colore, margin: '20px', padding: '20px', border: colore_bordo, borderRadius: '2vmin' };
    return hStyle;
  }

  //  margin: 20px;
  //  padding: 20px;
  //  border: 1px solid red;

  const popover1 = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Popover right</Popover.Header>
      <Popover.Body>
        And here's some amazing content. It's very engaging.
        right?
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="container">
      <Container>
        <Row>
          <Col>
            <Call_php_iniziale dati_utente={dati_utente}
              lista_file_mp3={lista_file_mp3}
              funzione_set_lista_file={SET_lista_file_mp3}
              funzione_set_dati_utente={funzione_set_dati_utente}
              funzione_set_lista_materie={SET_lista_materie}
              set_funzione_aggiorna_lista={SET_aggiorna_lista}
              SET_funzione_play_lista={SET_funzione_play_lista}
            />
            <Play_in_automatico funzione_play_spunta_ripetuto={funzione_play_spunta_ripetuto} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Nuova_domanda SET_lista_file_mp3={SET_lista_file_mp3}
              SET_aggiorna_lista={SET_aggiorna_lista}
              lista_file_mp3={lista_file_mp3}
              play_lista={play_lista}
              valore_minimo_sottrazione={valore_minimo_sottrazione}

            />
          </Col>

        </Row>
        <Row>
          <Col sm={4}>
            <Salvataggio dati_utente={dati_utente}
              lista_file_mp3={lista_file_mp3}
              lista_materie={lista_materie}
              aggiornamento={salva_dati}
              SET_salva_dati={SET_salva_dati} />
            <Scegli_materie lista_materie={lista_materie}
              SET_lista_materie={SET_lista_materie}
              lista_file_mp3={lista_file_mp3} SET_lista_file_mp3={SET_lista_file_mp3}
              set_funzione_aggiorna_lista={SET_aggiorna_lista}
              play_lista={play_lista}
              SET_funzione_play_lista={SET_funzione_play_lista}
              valore_minimo_sottrazione={valore_minimo_sottrazione} SET_valore_minimo_sottrazione={SET_valore_minimo_sottrazione}
              aggiorna_lista_file_stornati={aggiorna_lista_file_stornati} SET_aggiorna_lista_file_stornati={SET_aggiorna_lista_file_stornati}
            />
          </Col>
          <Col sm={8}>
            {play_lista.map(function (indice_vero, index2) {
              if (index2 < 10) {
                //        console.log(item2)
                var item = lista_file_mp3[indice_vero]
                //        console.log(item)
                var inplay = 'Play'
                if (play_indice == indice_vero) {
                  inplay = '<<< Play >>>>'
                }
                {
                  return <div style={colorazione(indice_vero)}>

                    <Row>
                      <Col>
                        {index2 + ' - ' + indice_vero}

                      </Col>
                    </Row>
                    <Row>
                      <p></p>
                    </Row>
                    <Row>
                      <Col>
                        {lista_file_mp3[indice_vero].domanda}
                      </Col>

                    </Row>
                    <Row>
                      <Col>
                        {item.indice_end}

                      </Col>
                      <Col>
                        <Gestione_file_mp3
                          indice_vero={indice_vero}
                          inplay={inplay}
                          lista_file_mp3={lista_file_mp3}
                          play_spunta_ripetuto={play_spunta_ripetuto} play_ripetuto={play_ripetuto}
                          funzione_play_ripetuto={funzione_play_ripetuto}

                          funzione_play_indice={funzione_play_indice}
                        />
                      </Col>

                    </Row>


                    <Row>
                      <div class="col-auto mr-auto"></div>
                      <div class="col-auto">
                        <File_mp3_load item={item} />
                      </div>
                    </Row>



                    <Row>
                      <Col>
                        <Dropdown_materie index2={indice_vero} lista_file_mp3={lista_file_mp3}
                          lista_materie={lista_materie}
                          funzione_set_lista_file={SET_lista_file_mp3}
                          set_funzione_aggiorna_lista={SET_aggiorna_lista} />
                      </Col>
                      <Col>
                        <Dropdown_jump index2={indice_vero} lista_file_mp3={lista_file_mp3}
                          SET_lista_file_mp3={SET_lista_file_mp3}
                          SET_aggiorna_lista={SET_aggiorna_lista}
                          trova_mp3_per_play={trova_mp3_per_play} />
                      </Col>
                      <Col>
                        <Accordion_risposta funzione_set_lista_file={SET_lista_file_mp3}
                          lista_file_mp3={lista_file_mp3}
                          SET_aggiorna_lista={SET_aggiorna_lista}

                          index3={indice_vero} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Risposta_visualizza
                          lista_file_mp3={lista_file_mp3}

                          index3={indice_vero} />
                      </Col>
                    </Row>
                  </div>
                }
                //        funzione_play_lista(lista_aux)
              }
            }
            )
            }

          </Col>

        </Row>
      </Container>
    </div>
  )
}

export default App;